module.exports = __webpack_public_path__ + "media/images/scary-mommy-5e040954b2eafdabb5f6935aba6e2af6.svg";